import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 013_archive_legacy_invoice_source_tables
//
// Active SINV/CN/DN ownership moved to Accounting in #767. Keep the old
// Sales-owned physical tables for audit/backfill history, but rename them so
// they cannot be mistaken for live document tables.
// ============================================================================

export const migration: ModuleMigrationDef = {
  key: "013_archive_legacy_invoice_source_tables",
  version: "1.13.0",
  ignoreErrors: [
    "no such table: sales_invoices",
    "no such table: sales_credit_notes",
    "no such table: sales_debit_notes",
  ],
  sql: `
ALTER TABLE \`sales_invoices\` RENAME TO \`sales_legacy_invoices_archive\`;
ALTER TABLE \`sales_credit_notes\` RENAME TO \`sales_legacy_credit_notes_archive\`;
ALTER TABLE \`sales_debit_notes\` RENAME TO \`sales_legacy_debit_notes_archive\`;
  `.trim(),
};
